
export default function(e, t) {
        return (t || document).querySelector(e)
    };
